'use client';

import React, { useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { AnimatePresence, m, useMotionValueEvent, useScroll } from 'motion/react';
import { css } from 'styled-system/css';

import { IconButton } from '@shaojiang/components/ui/icon-button';
import { fadeScaleVariants } from '@shaojiang/lib/motion';

/** Appears after scrolling down a screen or so. */
export function ScrollToTop({ label }: { label: string }) {
  const { scrollY } = useScroll();
  const [visible, setVisible] = useState(false);
  useMotionValueEvent(scrollY, 'change', (y) => setVisible(y > 900));

  return (
    <AnimatePresence>
      {visible && (
        <m.div
          className={css({ position: 'fixed', right: '6', bottom: '6', zIndex: 'sticky' })}
          variants={fadeScaleVariants}
          initial='closed'
          animate='open'
          exit='closed'
        >
          <IconButton
            variant='surface'
            size='lg'
            aria-label={label}
            title={label}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <ArrowUp />
          </IconButton>
        </m.div>
      )}
    </AnimatePresence>
  );
}
